// Feature 011 — small badge surfaced next to users who still owe their first
// login (FR-022).
export function FirstLoginBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5">
      Awaits first login
    </span>
  );
}
